export default __webpack_public_path__ + "static/media/sleigh.5fc4b525.svg";